export default [
  {
    path: '/real-estate-developments/:id/mirrors/new',
    name: 'RealEstateDevelopmentsMirrorsCreate',
    component: () => import('pages/real-estate-developments/tabs/mirrors/MirrorsForm.vue')
  },
  {
    path: '/real-estate-developments/:parentId/mirrors/:id/edit',
    name: 'RealEstateDevelopmentsMirrorsEdit',
    component: () => import('pages/real-estate-developments/tabs/mirrors/MirrorsForm.vue')
  }
]
